"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericMessages = exports.positiveNegativeInProgressMessages = exports.yesNoMessages = exports.sexMessages = exports.fsnMessages = void 0;
const fsn_1 = require("../../forms/messages/fsn");
const commonFsnMessages = {
    "fyrms|general_practitioner_of_the_patient": {
        id: "fyrms|general_practitioner_of_the_patient",
        defaultMessage: "A beteg háziorvosa"
    },
    "loinc|55174-7": {
        id: "loinc|55174-7",
        defaultMessage: "Beteg azonosítási adatok DEEDS"
    },
    "loinc|56799-0": {
        id: "loinc|56799-0",
        defaultMessage: "Cím"
    },
    "snomed|169812000": {
        id: "snomed|169812000",
        defaultMessage: "Születési hely"
    },
    "snomed|184095009": {
        id: "snomed|184095009",
        defaultMessage: "Beteg keresztneve"
    },
    "snomed|184096005": {
        id: "snomed|184096005",
        defaultMessage: "Beteg vezetékneve"
    },
    "snomed|184097001": {
        id: "snomed|184097001",
        defaultMessage: "Beteg címe"
    },
    "snomed|184098006": {
        id: "snomed|184098006",
        defaultMessage: "Beteg titulusa"
    },
    "snomed|184099003": {
        id: "snomed|184099003",
        defaultMessage: "Születési dátum"
    },
    "snomed|184107009": {
        id: "snomed|184107009",
        defaultMessage: "Beteg kórházi száma"
    },
    "snomed|302147001": {
        id: "snomed|302147001",
        defaultMessage: "Demográfiai történet részletek"
    },
    "snomed|315354004": {
        id: "snomed|315354004",
        defaultMessage: "Születési ország"
    },
    "snomed|398093005": {
        id: "snomed|398093005",
        defaultMessage: "Társadalombiztosítási szám"
    },
    "snomed|423203003": {
        id: "snomed|423203003",
        defaultMessage: "Leánykori név"
    },
    "snomed|423775007": {
        id: "snomed|423775007",
        defaultMessage: "Anya leánykori neve"
    },
    "snomed|734000001": {
        id: "snomed|734000001",
        defaultMessage: "Biológiai nem"
    },
    "snomed|734005006": {
        id: "snomed|734005006",
        defaultMessage: "Telefonszám"
    }
};
exports.fsnMessages = {
    ...commonFsnMessages,
    ...fsn_1.messages
};
exports.sexMessages = {
    MALE: {
        id: "sex.male",
        defaultMessage: "Férfi"
    },
    FEMALE: {
        id: "sex.female",
        defaultMessage: "Nő"
    },
    OTHER: {
        id: "sex.other",
        defaultMessage: "Egyéb"
    }
};
exports.yesNoMessages = {
    YES: {
        id: "yes_no.yes",
        defaultMessage: "Igen"
    },
    NO: {
        id: "yes_no.no",
        defaultMessage: "Nem"
    }
};
exports.positiveNegativeInProgressMessages = {
    POSITIVE: {
        id: "positive_negative_in_progress.positive",
        defaultMessage: "Pozitív"
    },
    NEGATIVE: {
        id: "positive_negative_in_progress.negative",
        defaultMessage: "Negatív"
    },
    IN_PROGRESS: {
        id: "positive_negative_in_progress.in_progress",
        defaultMessage: "Folyamatban"
    }
};
exports.genericMessages = {
    yearsOfAge: {
        id: "generic.years_of_age",
        defaultMessage: "{years} éves"
    },
    days: {
        id: "generic.days",
        defaultMessage: "{days} napja"
    },
    copy: {
        id: "generic.copy",
        defaultMessage: "Másolás"
    }
};
